/* eslint-disable react/require-default-props */
import React from 'react';
import { Container } from './styles';

interface ModalConLicitaIAProps {
  show: boolean;
  title: string;
  description: React.ReactNode;
  onClose: () => void;
  navbar?: boolean;
}

const ModalConLicitaIA: React.FC<ModalConLicitaIAProps> = ({
  show,
  title,
  description,
  onClose,
  navbar,
}) => {
  if (!show) return null;

  return (
    <Container
      $navbar={navbar}
      className={`${navbar ? 'justify-content-start' : 'justify-content-center'}`}
    >
      <div className="resumo-backdrop mt-2">
        <div className="resumo-modal">
          <button type="button" id="resumo-close" onClick={onClose}>
            ✕
          </button>

          <h4 className="resumo-title">{title}</h4>

          <div className="resumo-content">{description}</div>
        </div>
      </div>
    </Container>
  );
};

export default ModalConLicitaIA;
